import "./polyfills";
import React, { Suspense } from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles/chatbot.css";
import "./styles/aos.css";
import "./styles/keenicons.css";
import "./styles/bootstrap-icons.min.css";
import "./styles/bootstrap.min.css";
import "./styles/style.css";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { store } from "./store.js";
import App from "./App.js";
import Loader from "./components/Loader";

const sanitizeInitialUrl = () => {
  // Browser fragments are not sent to the server, so normalize '/#' in-app.
  const { href, hash, pathname, search } = window.location;
  const hasEmptyTrailingHash =
    hash === "#" || hash === "#/" || href.endsWith("/#");

  if (hasEmptyTrailingHash) {
    window.history.replaceState(
      window.history.state,
      document.title,
      `${pathname}${search}`
    );
  }
};

sanitizeInitialUrl();

const container = document.getElementById("root");

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </BrowserRouter>
  </Provider>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
